import { Grid } from "@chakra-ui/react";
import { EmptyState } from "src/components/EmptyState";
import PaperAnalyticsSvg from "src/images/paper-analytics.svg?react";

export const EmptyDashboard = () => {
  return (
    <Grid placeContent="center" height="100%" flexGrow="1">
      <EmptyState
        Svg={PaperAnalyticsSvg}
        heading="Welcome! There's nothing to report...yet!"
        description="Set up a form and visualize the responses here"
      />
    </Grid>
  );
};
